/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Daily_Paywall_Allow_List_Name_WorkInputs */

const en_daily_paywall_allow_list_name_work = /** @type {(inputs: Daily_Paywall_Allow_List_Name_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Work`)
};

const ar_daily_paywall_allow_list_name_work = /** @type {(inputs: Daily_Paywall_Allow_List_Name_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عمل`)
};

const de_daily_paywall_allow_list_name_work = /** @type {(inputs: Daily_Paywall_Allow_List_Name_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arbeit`)
};

const es_daily_paywall_allow_list_name_work = /** @type {(inputs: Daily_Paywall_Allow_List_Name_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabajar`)
};

const fr_daily_paywall_allow_list_name_work = /** @type {(inputs: Daily_Paywall_Allow_List_Name_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Travailler`)
};

const it_daily_paywall_allow_list_name_work = /** @type {(inputs: Daily_Paywall_Allow_List_Name_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lavora`)
};

const ja_daily_paywall_allow_list_name_work = /** @type {(inputs: Daily_Paywall_Allow_List_Name_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`仕事`)
};

const ko_daily_paywall_allow_list_name_work = /** @type {(inputs: Daily_Paywall_Allow_List_Name_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`업무`)
};

const pt_br_daily_paywall_allow_list_name_work = /** @type {(inputs: Daily_Paywall_Allow_List_Name_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabalhar`)
};

const ru_daily_paywall_allow_list_name_work = /** @type {(inputs: Daily_Paywall_Allow_List_Name_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Работа`)
};

const th_daily_paywall_allow_list_name_work = /** @type {(inputs: Daily_Paywall_Allow_List_Name_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทำงาน`)
};

const tr_daily_paywall_allow_list_name_work = /** @type {(inputs: Daily_Paywall_Allow_List_Name_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İş`)
};

const zh_cn_daily_paywall_allow_list_name_work = /** @type {(inputs: Daily_Paywall_Allow_List_Name_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`工作`)
};

const zh_tw_daily_paywall_allow_list_name_work = /** @type {(inputs: Daily_Paywall_Allow_List_Name_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`工作`)
};

/**
* | output |
* | --- |
* | "Work" |
*
* @param {Daily_Paywall_Allow_List_Name_WorkInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const daily_paywall_allow_list_name_work = /** @type {((inputs?: Daily_Paywall_Allow_List_Name_WorkInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Daily_Paywall_Allow_List_Name_WorkInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_daily_paywall_allow_list_name_work(inputs)
	if (locale === "ar") return ar_daily_paywall_allow_list_name_work(inputs)
	if (locale === "de") return de_daily_paywall_allow_list_name_work(inputs)
	if (locale === "es") return es_daily_paywall_allow_list_name_work(inputs)
	if (locale === "fr") return fr_daily_paywall_allow_list_name_work(inputs)
	if (locale === "it") return it_daily_paywall_allow_list_name_work(inputs)
	if (locale === "ja") return ja_daily_paywall_allow_list_name_work(inputs)
	if (locale === "ko") return ko_daily_paywall_allow_list_name_work(inputs)
	if (locale === "pt_br") return pt_br_daily_paywall_allow_list_name_work(inputs)
	if (locale === "ru") return ru_daily_paywall_allow_list_name_work(inputs)
	if (locale === "th") return th_daily_paywall_allow_list_name_work(inputs)
	if (locale === "tr") return tr_daily_paywall_allow_list_name_work(inputs)
	if (locale === "zh_cn") return zh_cn_daily_paywall_allow_list_name_work(inputs)
	return zh_tw_daily_paywall_allow_list_name_work(inputs)
});